/**
 * The Play button's label ("Spielen" / "Play") as an etchable glyph-outline SVG — the shared
 * construction in `glyph-word.js`, whose header carries the why. Glyph data is one author-
 * extracted set per possible localized word (`game-start-play-label-glyphs.js`, regenerated via
 * `scripts/doc-tools/extract-glyphs.py`).
 *
 * The label is a fixed, localized word — never the dynamic run context (which lives on the mode
 * card), precisely because only a known set of letters can be pre-extracted into etchable paths.
 */
import { PLAY_LABEL_GLYPHS } from "./game-start-play-label-glyphs.js";
import { buildGlyphWordSvg } from "../glyph-word.js";

/**
 * The label SVG for `word`, one filled <path> per letter in `inkColor`. Returns null when `word`
 * has no extracted glyph set (a language added without its glyphs) — the caller falls back to a
 * plain text label.
 */
export function buildPlayLabelSvg(word, inkColor) {
  const data = PLAY_LABEL_GLYPHS[word];
  if (data == null) return null;
  return buildGlyphWordSvg(data, inkColor, {
    className: "play-button-label-text",
    ariaLabel: word,
  });
}
